import Switch from 'react-switch';

const CustomSwitch = ({ onChange, checked, disabled }) => {
  return (
    <Switch
      onColor={disabled ? '#644839' : '#E78850'}
      offColor="#644839"
      disabled={disabled}
      checked={checked}
      onChange={onChange}
      checkedIcon={false}
      uncheckedIcon={false}
      height={32}
      width={52}
    />
  );
};

export default CustomSwitch;
